import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperModule } from 'swiper/angular';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedMaterialModule } from '../shared-material/shared-material.module';
import { RouterModule } from '@angular/router';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SearchGameComponent } from '../../components/games/search-game/search-game.component';
import { SEARCH_MODULE_NOT_TRANSLATED } from './search-routes';
import { SharedSearchModule } from './shared-search.module';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    SearchGameComponent
  ],
  imports: [
    RouterModule.forChild(SEARCH_MODULE_NOT_TRANSLATED),
    CommonModule,
    SharedMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    SharedComponentsModule,
    SwiperModule,
    MatDatepickerModule,
    SharedSearchModule,
    MatIconModule,
  ],
})
export class SearchMobileModule {

}
